import { createEffect, createMemo, createSignal, JSX, untrack } from 'solid-js';
import { formatCamelOrPascalToTitleCaseWords } from '@trimble/utilities';
import { Region } from '../types/project-select.types';
import { DropdownSelect } from '@trimble/ui-components/solidjs';

interface RegionSelectProps {
  regions: Region[];
  selectedRegion: Region;
  onRegionChange(region: Region): void;
}

export const RegionSelect = (props: RegionSelectProps): JSX.Element => {
  const [selectedRegion, setSelectedRegion] = createSignal<Region>(
    untrack(() => props.selectedRegion)
  );

  const getRegionOptions = createMemo(() => {
    return props.regions.map((region) => ({
      key: region.location,
      label: formatCamelOrPascalToTitleCaseWords(region.location),
    }));
  });

  const handleRegionChange = (value: string): void => {
    const tcRegion = props.regions.find((region) => region.location === value);
    if (!tcRegion) return;

    setSelectedRegion(tcRegion);
    props.onRegionChange(tcRegion);
  };

  createEffect(() => {
    setSelectedRegion(props.selectedRegion);
  });

  return (
    <div data-testid="region-selector">
      <DropdownSelect
        dropDownClassName="bg-base-page [&_li]:!text-base-content [&_li.active]:!bg-primary-pale [&_li.active]:hover:!bg-primary-pale [&_li.active]:!text-primary [&_li.active]:font-semibold [&_li:not(.active):hover]:!bg-gray-light"
        options={getRegionOptions()}
        value={selectedRegion().location}
        onValueChange={handleRegionChange}
      />
    </div>
  );
};

export default RegionSelect;
